import React, { ReactNode } from 'react';
import { AssetPreviewTable } from '../AssetsPreviewItems/AssetPreviewTable';
import { PORTAL_TARGETS } from '@/types/shared/navigation-tabs.enums';
import { ColumnDef } from '@tanstack/react-table';

interface TableViewProps<T> {
  items: T[];
  columns: ColumnDef<T>[];
  renderSearchInto?: PORTAL_TARGETS;
  emptyStateMessage?: { icon?: ReactNode; message?: ReactNode };
  rowClickHandler?: (data: T) => void;
  /**
   * The ID of the currently selected row. When this matches a row's ID (extracted via getRowId),
   * that row will be highlighted with a primary-colored background and border.
   */
  selectedRowId?: string | null;
  /**
   * Function to extract the unique ID from each row's data.
   * This allows the table to work with different data structures that have different ID field names
   * (e.g., fault_id, asset_id, id, uuid, etc.).
   * @example getRowId={(row) => row.fault_id}
   */
  getRowId?: (row: T) => string;
}

export const TableView = <T,>({
  items,
  columns,
  renderSearchInto,
  emptyStateMessage,
  rowClickHandler,
  selectedRowId,
  getRowId,
}: TableViewProps<T>) => {
  return (
    <AssetPreviewTable<T>
      columns={columns}
      data={items}
      renderSearchInto={renderSearchInto}
      emptyStateMessage={emptyStateMessage}
      rowClickHandler={rowClickHandler}
      selectedRowId={selectedRowId}
      getRowId={getRowId}
    />
  );
};
